import SlowlyTwoTTF from "./fonts/Slowly-Two.ttf";
import SlowlyTwoWOFF from "./fonts/Slowly-Two.woff";

export default {
    SlowlyTwoTTF,
    SlowlyTwoWOFF
};
